<template>
  <div class="container mx-auto">
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="3" xl="3"></CCol>
      <CCol xs="12" sm="12" md="12" lg="12" xl="12">
        <!-- <CCard class="pb-3"> -->
        <CCardHeader class="d-flex justify-content-between">
          <b
            ><span
              ><i class="fab fa-whatsapp"></i>&nbsp;Enviar promociones</span
            ></b
          >
          <button
            @click="returnHome"
            type="button"
            class="btn btn-sm text-white"
            style="background: #e46666"
          >
            <i class="fas fa-hand-point-left"></i> Retroceder
          </button>
        </CCardHeader>
        <!-- </CCard> -->
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="4" xl="4" class="mt-2">
        <span style="text-align: center"
          ><h4><b>MENSAJE PARA ENVIAR</b></h4></span
        >
        <textarea
          rows="20"
          placeholder="ESCRIBA UN MENSAJE PARA ENVIAR, PUEDE AÑADIR EMOTICONES."
          class="form-control form-control-sm"
          v-model="message"
        ></textarea>
        <span
          >** Para colocar el nombre del cliente en automatico presione aqui:
          <button class="btn btn-sm btn-info w-100" @click="mtdAddNameClientWsp">
            Añadir nombre de cliente
          </button></span
        ><br />
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="4" xl="4" class="mt-2">
        <span style="text-align: center"
          ><h4><b>Imagen para enviar (opcional):</b></h4></span
        >
        <input
          type="file"
          @change="handleImage"
          accept="image/*,video/*"
          class="form-control form-control-sm"
          ref="imageInput"
        />
        <template v-if="imagePreview">
          <img
            v-if="imageFile && imageFile.type.startsWith('image/')"
            :src="imagePreview"
            alt="promocion"
            class="img-fluid rounded m-2"
            style="max-height: 200px"
          />
          <video
            v-else-if="imageFile && imageFile.type.startsWith('video/')"
            :src="imagePreview"
            controls
            class="img-fluid rounded m-2"
            style="max-height: 200px"
          ></video>
        </template>
        <button
          @click="mtdSendWsp"
          class="btn btn-sm btn-success w-100 mt-2"
        >
          <i class="far fa-paper-plane"></i> Enviar mensaje
        </button>
      </CCol>
    </CRow>
  </div>
</template>
  
  <script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "c-proccess-katalynas-send",
  data() {
    return {
      message: "",
      castMessagge: {},
      /** img */
      imageFile: null,
      imagePreview: null,
    };
  },
  created() {},
  methods: {
    ...mapActions(["get", "post"]),
    returnHome() {
      this.$emit("returnHome");
    },
    formatDate(date) {
      return moment(date).format("DD/MM");
    },
    mtdAddNameClientWsp: function () {
      this.message += " nombre_cliente ";
    },
    handleImage(event) {
      const file = event.target.files[0];
      if (file) {
        this.imageFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          const fileType = file.type.split('/')[0];
          if (fileType === "image") {
            this.imagePreview = e.target.result;
          } else if (fileType === "video") {
            this.imagePreview = URL.createObjectURL(file);
          }
        };
        if (file.type.startsWith("image/")) {
          reader.readAsDataURL(file);
        } else if (file.type.startsWith("video/")) {
          // Para video no usamos base64, sino URL.createObjectURL
          this.imagePreview = URL.createObjectURL(file);
        } else {
          this.imageFile = null;
          this.imagePreview = null;
        }
      }
    },
    mtdSendWsp: function () {
      const formData = new FormData();
      formData.append("wsp", JSON.stringify(this.message));
      if (this.imageFile) {
        formData.append("image", this.imageFile);
      }
      this.post({
        url: this.$store.getters.get__url + "/promotion/send/wsp",
        token: this.$store.getters.get__token,
        params: formData,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.select = [];
            this.message = "";
            Swal.fire({
              title: "MENSAJES ENVIADOS!!.",
              icon: "success",
            });
            this.message = "";
            this.castMessagge = {};
            /** img */
            this.$refs.imageInput.value = null;
            this.imageFile = null;
            this.imagePreview = null;
          }
        })
        .catch((errors) => {});
    },
  },
};
</script>
  
  <style scoped>
.grid {
  display: grid;
  gap: 1rem;
}
.scroll-container {
  max-height: calc(100vh - 150px); /* Ajusta si tu header es más grande */
  overflow-y: auto;
  padding-right: 8px; /* Espacio para scroll */
}
</style>
  